import React, { useState, useEffect, useRef } from "react";
import { Container, Col, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRotateRight,
  faLock,
  faPencil,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { columnData } from "../../content/static";
import { handleSorting } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserAction,
  deleteUserAction,
  updatePasswordAction,
  updateUserAction,
  userListAction,
} from "../../redux/actions/user.action";
import UserModel from "../../section/UserModal";
import DeleteComponent from "../../components/Event/DeleteComponent";
import "./Profile.css"
// import Alert from 'react-bootstrap/Alert';
const initialStateOfModal = {
  firstname: "",
  lastname: "",
  email: "",
  role: "",
  status: "",
  eisId: "",
  password: "",
  userId: undefined,
  modalType: "",
};



const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(undefined);

  const [rowData, setRows] = useState([]);
  
  const [tableData, setTableData] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});

  const dispatch = useDispatch();
  const { userList } = useSelector((state) => state.user);

  // Add Modal open close state
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (!userList) {
      dispatch(userListAction());
    } else {
      setRows(userList);
      setTableData(userList);
    }
  }, [userList]); // eslint-disable-line react-hooks/exhaustive-deps




  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");


  const handleSortingChange = (accessor) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);

    const sorted = handleSorting(accessor, sortOrder, rowData); // Sort the currently displayed data
    if (sorted) {
      setRows(sorted);
    }
  };

  const setErrorHandle = (name, value) => {
    setErrorMessage({ ...errorMessage, [name]: value });
  };

  const clickReload = () => {
    if (inputSearchRef.current) {
      inputSearchRef.current.value = "";
    }
    setRows(tableData);
    setSortField("");
    setOrder("asc");
  };

  const inputSearchRef = useRef(null);

  const handleSearch = (event) => {
    const { value } = event.target;

    
    if (!value) {
      // If search is empty, reset to original data
      setRows(tableData);
      return;
    }

    if (value.length >= 3) {
      const searchTerm = value.toLowerCase();
      const filteredData = tableData.filter((row) => {
        return Object.keys(row).some((key) => {
          // Handle nested objects if needed (like subareaId)
          const cellValue = typeof row[key] === 'object'
            ? JSON.stringify(row[key])
            : String(row[key]);
          return cellValue.toLowerCase().includes(searchTerm);
        });
      });

      setRows(filteredData);
    }else{
       setRows(tableData);
    }

  };


  // add modal
  const showAddModal = () => {
    setModal(!modal);
  };

  // edit modal
  const showEditForm = (e) => {
    const { _id, userId, ...rest } = e;

    setData({
      ...rest,
      userId: _id || userId,
      modalType: "Update User",
    });

    showAddModal();
  };

  const [error, setError] = useState(null);

  // change password modal
  const showChangePassword = (e) => {
    setData({
      ...initialStateOfModal,
      userId: e,
      modalType: "password Update",
    });

    showAddModal();
  };

  const [data, setData] = useState({
    ...initialStateOfModal,
  });

  const newUserModal = (e) => {
    setData({
      ...initialStateOfModal,
      modalType: "Register New User",
    });
    showAddModal();
  };

  const errorMessages = {
    firstName: "Please enter first name",
    lastName: "Please enter last name",
    Email: "Please enter email",
    password: "Please enter password",
    role: "Please enter role",
    EISId: "Please enter EISId",
    status: "Please enter status",
    subareaId: 'Please enter subarea id'
  };

  const handleData = (name, value) => {
    setData({ ...data, [name]: value });
  };

  const onModalSubmit = () => {
    if (data.modalType === "password Update") {
      dispatch(updatePasswordAction(data));
      setModal(false);
      return;
    }

    if (
      /@kgkmail.com\s*$/.test(data.email) ||
      /@sparklesoft.co.in\s*$/.test(data.email)
    ) {
      if (data.userId || data.modalType === "Update User") {
        //update

        const { password, ...restObj } = data;
        // const date = ;

        dispatch(updateUserAction(restObj, data.userId));

      } else {
        // create
        dispatch(addUserAction(data));
      }
      setModal(false);
    } else {
      setError("Invalid email domain!");
    }

    if (!data.firstname || data.firstname === "") {
      setErrorHandle("firstName", errorMessages.firstName);
      return;
    } else if (!data.lastname || data.lastname === "") {
      setErrorHandle("lastName", errorMessages.lastName);

      return;
    } else if (!data.email || data.email === "") {
      setErrorHandle("Email", errorMessages.Email);

      return;
    } else if (!data.password || data.password === "") {
      setErrorHandle("password", errorMessages.password);

      return;
    } else if (!data.role || data.role === "") {
      setErrorHandle("role", errorMessages.role);

      return;
    } else if (!data.eisId || data.eisId === "") {
      setErrorHandle("EISId", errorMessages.EISId);

      return;
    } else if (!data.subareaId || data.subareaId === "") {
      setErrorHandle("subareaId", errorMessages.subareaId);
    } else {
      let errorMessageTemp = {};
      Object.keys(errorMessages).forEach((key) => {
        errorMessageTemp[key] = null;
      });
      setErrorMessage(errorMessageTemp);
    }
  };

  const handleCancelDelete = () => setShowDeleteModal(undefined);

  const handleConfirmDelete = () => {
    dispatch(deleteUserAction(showDeleteModal));
    handleCancelDelete();
  };
  const ActionBar = ({ item }) => {
    const clickCallbackEdit = () => {
      showEditForm(item);
    };
    const clickCallbackDelete = () => setShowDeleteModal(item._id);
    const clickChangePassword = () => {
      showChangePassword(item._id);
    };
    return (
      <>
        <FontAwesomeIcon
          icon={faPencil}
          className="text-primary px-1 cursor-pointer"
          title="Edit"
          onClick={clickCallbackEdit}
        />
        <FontAwesomeIcon
          icon={faTrash}
          className="text-danger px-1 cursor-pointer"
          title="Delete"
          onClick={clickCallbackDelete}
        />
        <FontAwesomeIcon
          icon={faLock}
          className="text-warning px-1 cursor-pointer"
          title="Change Password"
          onClick={clickChangePassword}
        />
      </>
    );
  };

  return (
    <>
      <Container fluid className="px-2 py-2">
        <div className="smartTable-container">
          <Col className="col-12 pt-2">
            {loading && (
              <div className="smartTable-loaderContainer text-primary">
                <div className="spinner-border" role="status"></div>
              </div>
            )}
            <div className="row">
              <div className="col-4 h4">User List</div>
              <div className="col-3">
                <input
                  type="text"
                  className="form-control pull-right"
                  placeholder="Search..."
                  onChange={handleSearch}
                  ref={inputSearchRef}
                />
              </div>
              <div className="col-5">
                <Button className="btn btn-info" onClick={clickReload}>
                  <FontAwesomeIcon icon={faArrowRotateRight} />
                </Button>
                <Button
                  className="btn btn-success pull-right cursor-pointer ml-2"
                  onClick={newUserModal}
                >
                  Add User
                </Button>
              </div>
            </div>

            <div className="row mt-3">
              <div className="smartTable-tableContainer">
                <table className="smartTable-table table table-striped border">
                  <thead className="smartTable-thead">
                    <tr>
                      {columnData.map(({ label, accessor, sortable }) => {
                        const cl = sortable
                          ? sortField === accessor && order === "asc"
                            ? "up"
                            : sortField === accessor && order === "desc"
                              ? "down"
                              : "default"
                          : "";
                        return (
                          <th
                            key={accessor}
                            onClick={sortable ? () => handleSortingChange(accessor) : null}
                            className={`${cl} smartTable-pointer`}
                          >
                            {label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {rowData.length > 0 ? (
                      rowData.map((item) => (
                        <tr key={item?._id}>
                          <td className="text-capitalize">
                            {item?.firstname} {item?.lastname}
                          </td>
                          <td>{item?.email || "-"}</td>
                          <td>
                            {typeof item?.subareaId === 'object'
                              ? item.subareaId.name || "-"
                              : item?.subareaId || "-"}
                          </td>
                          <td className="text-capitalize">{item?.role || "-"}</td>
                          <td className="text-capitalize">
                            {item?.status === "active" ? (
                              <span className="badge badge-pill badge-success status-Badge">
                                Active
                              </span>
                            ) : (
                              <span className="badge badge-pill badge-danger status-Badge">
                                Inactive
                              </span>
                            )}
                          </td>
                          <td>
                            {item?.updatedAt
                              ? moment(item?.updatedAt).format("ddd, MMM D YYYY, h:mm:ss a")
                              : "-"}
                          </td>
                          <td>
                            <ActionBar item={item} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No users found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        </div>
      </Container>

      <UserModel
        open={modal}
        data={data}
        handleData={handleData}
        setErrorHandle={setErrorHandle}
        toggleModel={showAddModal}
        onSubmit={onModalSubmit}
        errorMessage={errorMessage}
      />
      <DeleteComponent
        open={showDeleteModal}
        toggleModel={() => setShowDeleteModal(undefined)}
        title={"Are you sure?"}
        question={"You want to delete this user?"}
        handleCancelDelete={handleCancelDelete}
        handleConfirmDelete={handleConfirmDelete}
      />
    </>
  );
};
export default Profile;





